import {
  customFieldsPayloadConverter,
  ICustomFields,
  startOfDay,
} from 'modals/TimeOffModal/TimeOffModal.constants';
import {
  API_PUT_updateTimeOffParamsType,
  CustomFieldEntity,
} from 'requests/PUT_updateTimeOff.types';
import { CustomField } from 'types/graphql';
import { getStartEndDateTime } from 'modals/TimeOffModal/views/CreateTimeOffView/CreateTimeOffView.constants';
import { DateTime } from 'luxon';
import { getCurrentlySelectedLocation } from 'utils/getCurrentlySelectedLocation';

export const getPayCodeIdPayload = (
  payCodeId: string[],
  initialPayCodeId: string[],
): number | null | undefined => {
  if (payCodeId[0] === initialPayCodeId[0]) return undefined;
  if (!payCodeId.length) return null;
  return Number(payCodeId[0]);
};

export const updateTimeOffPayloadTransformer = (payload: {
  allDay: boolean;
  startDate: string[];
  endDate: string[];
  startTime: string[];
  endTime: string[];
  title: string[];
  notes: string;
  customFields: ICustomFields;
  timeOffCustomFields: CustomField[];
  payCodeId?: number | null;
}): API_PUT_updateTimeOffParamsType => {
  const {
    allDay,
    startDate,
    endDate,
    startTime,
    endTime,
    title,
    notes,
    customFields,
    timeOffCustomFields,
    payCodeId,
  } = payload;

  let [fromForTimeZone, toForTimeZone] = getStartEndDateTime({
    startDate,
    endDate,
    startTime,
    endTime,
    allDay,
  });

  const { timeZone } = getCurrentlySelectedLocation();

  const fromDateTime = DateTime.fromISO(fromForTimeZone).setZone(timeZone);
  let endDateTime = DateTime.fromISO(toForTimeZone).setZone(timeZone);

  if (endDateTime.toFormat('HH:mm:ss') === startOfDay[0])
    endDateTime = endDateTime.minus({ second: 1 });

  // Continue with the rest of the code...
  const custom_fields = customFieldsPayloadConverter(
    customFields,
    timeOffCustomFields,
  ) as CustomFieldEntity[];

  const start_date_time = {
    date: fromDateTime.toFormat('yyyy-MM-dd'),
    hour: fromDateTime.get('hour'),
    minute: fromDateTime.get('minute'),
  };

  const end_date_time = {
    date: endDateTime.toFormat('yyyy-MM-dd'),
    hour: endDateTime.get('hour'),
    minute: endDateTime.get('minute'),
  };

  return {
    time_off: {
      start_date_time,
      end_date_time,
      title: title[0],
      notes,
      custom_fields,
      ...(payCodeId !== undefined && { pay_code_id: payCodeId }),
    },
  };
};
